import { Pool } from "@/models/pool.model";
import { PoolDetails } from "@/models/pool-details.model";
import { cloneDeep } from "lodash";
import { deserializePlan } from "@/shared/utils/plans";
import { deserializeProbe } from "@/shared/utils/probes";
import { deserializeOut } from "@/shared/utils/outs";
import { deserializeAlert } from "@/shared/utils/alerts";
import { PoolListItem } from "@/models/pool-list-item.model";

export const deserializePool = (poolDetails: PoolDetails): Pool => {
  return {
    ...cloneDeep(poolDetails),
    plans: poolDetails.plans
      .filter((p) => p.plan || p.plan64)
      .map((p) => deserializePlan(p, poolDetails)),
    probes: poolDetails.probes.map(deserializeProbe),
    outs: poolDetails.outs.map(deserializeOut),
    alerts: poolDetails.alerts?.map(deserializeAlert) || [],
  };
};

export const isHivernage = (pool: PoolListItem | Pool): boolean => {
  const poolMode =
    "RegulModes" in pool
      ? pool.RegulModes?.PoolMode
      : "params" in pool
      ? pool.params.PoolMode
      : -1;
  if (poolMode === -1) {
    console.warn("PoolMode not found !", pool);
  }
  return poolMode === 4;
};
